const filterTypeMap: Record<string, string> = {
  '咸亨询价单': '75',
  // 后续扩展更多页面
}

export const getFilterTypeValue = (label: string) =>
  filterTypeMap[label] || ''

export type FilterTypeLabel = keyof typeof filterTypeMap
const filterTypeMap: Record<string, string> = {
  '咸亨询价单': '75',
  // 后续扩展更多页面
}

export const getFilterTypeValue = (label: string) =>
  filterTypeMap[label] || ''

export type FilterTypeLabel = keyof typeof filterTypeMap
